import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CookbookLanding.css";

export default function SaaSLandingPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Set document title and description
    document.title = "Cookbook Taste Factory";
    let metaDesc = document.querySelector('meta[name="description"]');
    let originalMetaDesc = "";
    if (metaDesc) {
      originalMetaDesc = metaDesc.content;
      metaDesc.content =
        "Experience modern dining at Cookbook Taste Factory. Visit our two branches today.";
    } else {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      metaDesc.content =
        "Experience modern dining at Cookbook Taste Factory. Visit our two branches today.";
      document.head.appendChild(metaDesc);
    }

    // Load fonts and icons dynamically
    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href =
      "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;800&family=Playfair+Display:ital,wght@0,600;1,600&display=swap";
    document.head.appendChild(fontLink);

    const faLink = document.createElement("link");
    faLink.rel = "stylesheet";
    faLink.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css";
    document.head.appendChild(faLink);

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      // Restore original description
      if (metaDesc && originalMetaDesc) {
        metaDesc.content = originalMetaDesc;
      }
      // Remove fonts/icons
      if (document.head.contains(fontLink)) document.head.removeChild(fontLink);
      if (document.head.contains(faLink)) document.head.removeChild(faLink);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToSection = (id) => {
    setIsMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="cookbook-landing-page">
      {/* Navigation */}
      <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
        <div className="container nav-container">
          <div
            className="logo"
            style={{ cursor: "pointer" }}
            onClick={() => scrollToSection("home")}
          >
            <h1>
              C<span>OO</span>KB<span>OO</span>K
            </h1>
            <p>TASTE FACTORY</p>
          </div>
          <ul className={`nav-links ${isMenuOpen ? "show" : ""}`}>
            <li>
              <a
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("home");
                }}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#branches"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("branches");
                }}
              >
                Branches
              </a>
            </li>
            <li>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("about");
                }}
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("contact");
                }}
              >
                Contact
              </a>
            </li>
          </ul>
          <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <header
        id="home"
        className="hero"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1514933651103-005eec06c04b?q=80&w=2000&auto=format&fit=crop')",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <h2>Welcome to</h2>
          <h1 className="hero-title">Cookbook</h1>
          <p className="hero-subtitle">
            Where culinary art meets exceptional taste.
          </p>
          <a
            href="#branches"
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("branches");
            }}
          >
            Choose Your Branch
          </a>
        </div>
      </header>

      {/* Branches Section */}
      <section id="branches" className="branches-section">
        <div className="container">
          <div className="section-title">
            <h2>Our Branches</h2>
            <p>Select a location to view our exclusive menus</p>
          </div>

          <div className="branches-grid">
            {/* Branch 1 */}
            <div className="branch-card">
              <div
                className="branch-image"
                style={{
                  backgroundImage:
                    "url('https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?q=80&w=2070&auto=format&fit=crop')",
                }}
              ></div>
              <div className="branch-info">
                <h3>COOKBOOK INDIAN RESTAURANT</h3>
                <p className="address">
                  <i className="fas fa-map-marker-alt"></i> NEW HARAJ, DAR
                  BAIDA, Saudi Arabia
                </p>
                <p className="hours">
                  <i className="far fa-clock"></i> 6:00 AM - 2:00 AM
                </p>
                <div className="branch-actions">
                  <Link to="/cook-book" className="btn btn-outline">
                    <i className="fas fa-book-open"></i> View Menu
                  </Link>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href="#"
                    className="btn btn-text"
                    onClick={(e) => e.preventDefault()}
                  >
                    Book Table <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Branch 2 */}
            <div className="branch-card">
              <div
                className="branch-image"
                style={{
                  backgroundImage:
                    "url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=2070&auto=format&fit=crop')",
                }}
              ></div>
              <div className="branch-info">
                <h3>COOKBOOK TASTY FACTORY</h3>
                <p className="address">
                  <i className="fas fa-map-marker-alt"></i> NEW INDUSTRY AREA,
                  DUBAI MARKET, Saudi Arabia
                </p>
                <p className="hours">
                  <i className="far fa-clock"></i> 5:00 AM - 12:00 PM
                </p>
                <div className="branch-actions">
                  <Link to="/taste-cookbook" className="btn btn-outline">
                    <i className="fas fa-book-open"></i> View Menu
                  </Link>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href="#"
                    className="btn btn-text"
                    onClick={(e) => e.preventDefault()}
                  >
                    Book Table <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="about-section">
        <div className="container about-container">
          <div
            className="about-image"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1414235077428-338988a2e8c0?q=80&w=2070&auto=format&fit=crop')",
            }}
          ></div>
          <div className="about-text">
            <h2>Our Story</h2>
            <p>
              Founded with a passion for extraordinary culinary experiences,
              Cookbook Taste Factory has been serving unforgettable meals since
              our inception. We believe in using only the freshest, locally
              sourced ingredients to craft dishes that not only satisfy your
              hunger but also delight your senses.
            </p>
            <p>
              Every recipe in our "cookbook" is a testament to our dedication to
              quality and flavor. Whether you're here for a quick lunch or a
              celebratory dinner, our vibrant atmosphere and impeccable service
              ensure a memorable visit.
            </p>
            <div className="features-grid">
              <div className="feature">
                <i className="fas fa-leaf"></i>
                <span>Fresh Ingredients</span>
              </div>
              <div className="feature">
                <i className="fas fa-motorcycle"></i>
                <span>Fast Delivery</span>
              </div>
              <div className="feature">
                <i className="fas fa-calendar-check"></i>
                <span>Event Catering</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="gallery-section">
        <div className="container">
          <div className="section-title">
            <h2>Taste The Art</h2>
            <p>A glimpse into our culinary creations</p>
          </div>
          <div className="gallery-grid">
            <div
              className="gallery-item"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=2000&auto=format&fit=crop')",
              }}
            ></div>
            <div
              className="gallery-item"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?q=80&w=2000&auto=format&fit=crop')",
              }}
            ></div>
            <div
              className="gallery-item"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1473093295043-cdd812d0e601?q=80&w=2000&auto=format&fit=crop')",
              }}
            ></div>
            <div
              className="gallery-item"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1555939594-58d7cb561ad1?q=80&w=2000&auto=format&fit=crop')",
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact">
        <div className="container footer-content">
          <div className="footer-brand">
            <h2>
              C<span>OO</span>KB<span>OO</span>K
            </h2>
            <p>Taste Factory</p>
            <div className="socials">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" onClick={(e) => e.preventDefault()}>
                <i className="fab fa-instagram"></i>
              </a>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" onClick={(e) => e.preventDefault()}>
                <i className="fab fa-facebook-f"></i>
              </a>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#" onClick={(e) => e.preventDefault()}>
                <i className="fab fa-twitter"></i>
              </a>
            </div>
          </div>
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <p>Email: cookbookrest@gmail.com</p>
            <p>Phone: +966 55 1234747</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Cookbook Taste Factory. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
